import ProjectData from '@/data/ProjectData.ts'

const otherProjects: ProjectData[] = []

export default otherProjects
